import React from "react"
import {breakpoints} from "@next/ux-fabric"
import RecentSearchClearButton from "../../../../components/RecentSearchClearButton"
import RecentSearches from "../../../../components/RecentSearches"
import {Container, Wrapper, HeaderContainer, HeaderText} from "../components"
import connect from "./connect"
import {
    SEARCH_DATA_GA,
    SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA,
    SEARCH_PREVIOUS_SEARCH_DATA_GA,
} from "../../../../config/constants"
import {useMediaQuery} from "../../../../hooks/useMediaQuery"

type HeaderProps = {
    clear: () => void
    text: any
    showClearAll: boolean
}

const Header = ({clear, text, showClearAll}: HeaderProps) => {
    const {mobileHeader, desktopHeader, clearAllButton} = text
    const isMdUp = useMediaQuery(`(min-width: ${breakpoints.values.md}px)`)

    return (
        <HeaderContainer className="recents-header" data-testid="recents-header">
            <HeaderText variant="subtitle2">{isMdUp ? mobileHeader : desktopHeader}</HeaderText>
            {showClearAll && (
                <RecentSearchClearButton
                    onClick={clear}
                    dataGaV1={SEARCH_DATA_GA}
                    dataGaV2={SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA}
                    dataGaV3={SEARCH_PREVIOUS_SEARCH_DATA_GA}
                >
                    {clearAllButton}
                </RecentSearchClearButton>
            )}
        </HeaderContainer>
    )
}
const Content = () => (
    <Wrapper data-testid="recents-body">
        <RecentSearches />
    </Wrapper>
)

export type RecentSearchesProps = {
    clear: () => void
    text: any
    showClearAll: boolean
}

export const SimpleRecentSearches = (props: RecentSearchesProps) => (
    <Container data-testid="header-simple-recent-searches" className="simple-recent-searches">
        <Header {...props} />
        <Content />
    </Container>
)

export default connect(SimpleRecentSearches)
